/*
 * @Author:
 * @Description:商户注册页面表单下拉数据
 * @Date: 2024-09-09 16:47:38
 * @LastEditors: Please set LastEditors
 * @FilePath: /rhcn-merchant-web/src/utils/options/networkApplication.js
 */

export const businessLocation = [
  {
    label: 'message.countryList.HK',
    value: 'Hong Kong SAR China',
  },
  {
    label: 'message.countryList.UK',
    value: 'United Kingdom',
  },
];

export const TypeofBusinessList = [
  {
    label: 'message.register.company', // 有限公司
    value: 'Company',
    link: 'Hong Kong SAR China',
  },
  {
    label: 'message.register.partnership', // 合伙业务
    value: 'Partnership',
    link: 'Hong Kong SAR China',
  },
  {
    label: 'message.register.soleProprietorship', // 独资经营
    value: 'Sole Proprietorship',
    link: 'Hong Kong SAR China',
  },
  {
    label: 'message.register.limited_liability_partnership/LLP', // 有限责任合伙/LLP
    value: 'Limited Liability Partnership/LLP',
    link: 'United Kingdom',
  },
  {
    label: 'message.register.unincorporated_partnership', // 非法人合伙
    value: 'Unincorporated Partnership,',
    link: 'United Kingdom',
  },
  {
    label: 'message.register.private_company', // 私人公司
    value: 'Private Company',
    link: 'United Kingdom',
  },
  {
    label: 'message.register.other', // 其他
    value: 'Other/I\'m not sure',
    link: 'United Kingdom',
  },
];
export const DurationOfOperationList = [
  {
    label: 'message.register.websiteOrApplication_desc.options.duration_of_operation.new',
    value: 'New',
  },
  {
    label: 'message.register.websiteOrApplication_desc.options.duration_of_operation.less_than_1_year',
    value: 'Less than 1 year',
  },
  {
    label: 'message.register.websiteOrApplication_desc.options.duration_of_operation.1_to_3_years',
    value: '1 to 3 years',
  },
  {
    label: 'message.register.websiteOrApplication_desc.options.duration_of_operation.more_than_3_years',
    value: 'More than 3 years',
  },

];
export const monthlyTradingVolumeUsdOptions = [
  {
    label: '0 - 50,000',
    value: '0 - 50,000',
  },
  {
    label: '50,001 - 100,000',
    value: '50,001 - 100,000',
  },
  {
    label: '100,001 - 300,000',
    value: '100,001 - 300,000',
  },
  {
    label: '300,001 - 600,000',
    value: '300,001 - 600,000',
  },
  {
    label: '600,000 or above',
    value: '600,000 or above',
  },
];
export const monthlyDisputeRateOptions = [
  {
    label: '0 - 0.5%',
    value: '0 - 0.5%',
  },
  {
    label: '0.5% - 0.9%',
    value: '0.5% - 0.9%',
  },
  {
    label: '0.9% - 1.5%',
    value: '0.9% - 1.5%',
  },
  {
    label: '1.5% - 3.0%',
    value: '1.5% - 3.0%',
  },
  {
    label: '3.0% or above',
    value: '3.0% or above',
  },
];
export const monthlyRefundRateOptions = [
  {
    label: '0 - 1.0%',
    value: '0 - 1.0%',
  },
  {
    label: '1.0% - 5.0%',
    value: '1.0% - 5.0%',
  },
  {
    label: '5.0% - 10.0%',
    value: '5.0% - 10.0%',
  },
  {
    label: '10.0% - 20.0%',
    value: '10.0% - 20.0%',
  },
  {
    label: '20.0% or above',
    value: '20.0% or above',
  },
];
export const marketOptions = [
  {
    label: 'message.register.marketOptions.hottest',
    options: [{
      value: 'North America',
      label: 'message.register.marketOptions.northAmerica',
    }, {
      value: 'Europe',
      label: 'message.register.marketOptions.europe',
    }],
  },
  {
    label: 'message.register.marketOptions.otherMarket',
    options: [{
      value: 'East Asia',
      label: 'message.register.marketOptions.eastAsia',
    }, {
      value: 'Southeast Asia',
      label: 'message.register.marketOptions.southeastAsia',
    },
    {
      value: 'Middle East',
      label: 'message.register.marketOptions.middleEast',
    },
    {
      value: 'Latin America',
      label: 'message.register.marketOptions.latinAmerica',
    },
    {
      value: 'Africa',
      label: 'message.register.marketOptions.africa',
    },
    {
      value: 'Oceania',
      label: 'message.register.marketOptions.ceania',
    },
    ],
  },
];
